import React, { useEffect, useRef, useState } from "react";
import {
  ArrowIcon,
  // BellIcon,
  // LanguagesIcon,
  LockIcon,
  // RadioButtonIcon,
  ThemeIcon
} from "../../Assets/assets";
import { setErrorStatus } from "../../Redux/status/action";
import Button from "../Button/Button";
// import CheckBox from "../CheckBox/CheckBox";
import ChangePassword from "./ChangePassword";
import { ProfileHeader } from "./ProfileHeader";

export default function Settings(props) {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const settingsRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (settingsRef.current && !settingsRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDropdownClick = (section) => {
    if (activeDropdown === section) {
      setActiveDropdown(null);
    } else if (activeDropdown) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(section);
    }
  };

  return (
    <div
      className="inherit-parent-height inherit-parent-width"
      ref={settingsRef}
    >
      <div className="height-inherit">
        <ProfileHeader
          name={props.profile?.data?.name}
          isOpen={activeDropdown === "profile"}
          setActive={setActiveDropdown}
          blur={activeDropdown && activeDropdown !== "profile"}
          activeDropdown={activeDropdown}
          updateProfile={props.updateProfile}
          setErrorStatus={setErrorStatus}
        />

        <SectionDropdown
          title="Change Password"
          isOpen={activeDropdown === "password"}
          onClick={() => handleDropdownClick("password")}
          icon={<LockIcon color="var(--tertiaryColor6)" />}
          blur={activeDropdown && activeDropdown !== "password"}
        >
          <ChangePassword
            email={props.profile?.data?.email}
            updatePassword={props.updatePassword}
            setActive={setActiveDropdown}
          />
        </SectionDropdown>

        {/* <SectionDropdown
          title="Notifications preference"
          isOpen={activeDropdown === "notifications"}
          onClick={() => handleDropdownClick("notifications")}
          icon={<BellIcon />}
          blur={activeDropdown && activeDropdown !== "notifications"}
        >
          <div
            className="border"
            style={{ border: "1px solid #353535", padding: "12px" }}
          >
            <CheckBox
              label="Receive all notifications"
              labelClassName="font-color-tertiaryColor text-capitalize font-size-medium padding-right-large"
              data-cy="allNotification-checkBox"
              name="allNotification-checkBox"
            />
          </div>
          <div
            className="border"
            style={{
              border: "1px solid #6E6E6E",
              padding: "12px",
              backgroundColor: "#FFFFFF14",
              marginTop: "8px"
            }}
          >
            <CheckBox
              label="New activity"
              labelClassName="font-color-tertiaryColor text-capitalize font-size-medium padding-right-large"
              onChange={props.onChange}
              data-cy="allNotification-checkBox"
              name="allNotification-checkBox"
            />
            <div className="font-size-small padding-left-larger padding-top-smaller">
              Receive notifications for new entries, updates on existing
              entries, and more.
            </div>
          </div>
        </SectionDropdown>

        <SectionDropdown
          title="Change language"
          isOpen={activeDropdown === "language"}
          onClick={() => handleDropdownClick("language")}
          icon={<LanguagesIcon />}
          blur={activeDropdown && activeDropdown !== "language"}
        >
          <div>
            <div
              className="display-flex flex-align-items-center padding-large margin-top-default"
              style={{
                border: "1px solid #6E6E6E",
                padding: "12px",
                backgroundColor: "#FFFFFF14",
                marginTop: "8px"
              }}
            >
              <RadioButtonIcon active />
              <div className="padding-left-medium">English</div>
            </div>
            <div
              className="display-flex flex-align-items-center padding-large margin-top-default"
              style={{ border: "1px solid #353535", padding: "12px" }}
            >
              <RadioButtonIcon />
              <div className="padding-left-medium">Tamil</div>
            </div>
            <div
              className="display-flex flex-align-items-center padding-large margin-top-default"
              style={{ border: "1px solid #353535", padding: "12px" }}
            >
              <RadioButtonIcon />
              <div className="padding-left-medium">Hindi</div>
            </div>
          </div>
        </SectionDropdown> */}

        <SectionDropdown
          title="Themes"
          isOpen={activeDropdown === "themes"}
          onClick={() => handleDropdownClick("themes")}
          icon={<ThemeIcon color="var(--tertiaryColor6)" />}
          blur={activeDropdown && activeDropdown !== "themes"}
        >
          <ThemesContainer
            onThemeClick={props.onThemeClick}
            selectedTheme={props.auth.theme}
          />
        </SectionDropdown>

        <LogoutSection
          activeDropdown={activeDropdown}
          setActiveDropdown={setActiveDropdown}
          logout={props.logout}
        />
      </div>
    </div>
  );
}

function SectionDropdown(props) {
  return (
    <div
      style={{
        backgroundColor: props.isOpen
          ? "var(--tertiaryColor3)"
          : "var(--tertiaryColor2)",
        opacity: props.blur ? "40%" : "100%"
      }}
      className="padding-large"
    >
      <div
        className="display-flex flex-justify-content-space-between flex-align-items-center"
        onClick={props.onClick}
        data-cy={`section-dropdown-${props.title}`}
      >
        <div className="display-flex flex-align-items-center">
          {props.icon}
          <div className="margin-left-medium font-color-tertiaryColor6 font-size-small">
            {props.title}
          </div>
        </div>
        <ArrowIcon color="var(--tertiaryColor6)" />
      </div>

      {props.isOpen && (
        <div className="margin-top-large margin-bottom-large">
          {props.children}
        </div>
      )}
    </div>
  );
}

const LogoutSection = (props) => {
  const handleLogoutClick = () => {
    if (props.activeDropdown) {
      props.setActiveDropdown(null);
    } else {
      props.setActiveDropdown("logout");
    }
  };

  return (
    <div
      className="position-absolute bottom-0 left-0 right-0 padding-large"
      style={{
        opacity:
          props.activeDropdown && props.activeDropdown !== "logout"
            ? "40%"
            : "100%",
        pointerEvents:
          props.activeDropdown && props.activeDropdown !== "logout"
            ? "none"
            : "auto"
      }}
    >
      {props.activeDropdown === "logout" ? (
        <div
          className="font-family-gilroy-medium text-align-center"
          data-cy="logout-confirmation-modal"
        >
          <div className="font-size-small padding-top-medium font-color-tertiaryColor6">
            Are you sure you want to logout?
          </div>
          <div className="display-flex padding-top-larger flex-justify-content-space-between">
            <div
              style={{
                width: "60%"
              }}
            >
              <Button
                boxShadow={false}
                type="button"
                text="Yes, Logout"
                className="margin-right-medium"
                onClick={() => {
                  props.logout();
                  props.setActiveDropdown(null);
                }}
                data-cy="confirm-logout-button"
                variant="danger"
              />
            </div>
            <div
              style={{
                width: "40%"
              }}
            >
              <Button
                boxShadow={false}
                type="button"
                onClick={() => {
                  props.setActiveDropdown(null);
                }}
                text="No, Stay logged in"
                variant="transparent"
                data-cy="cancel-logout-button"
              />
            </div>
          </div>
        </div>
      ) : (
        <div>
          <Button
            variant="danger"
            text="Log out"
            boxShadow={false}
            onClick={handleLogoutClick}
            data-cy="logout-button"
          />
        </div>
      )}
    </div>
  );
};

const DiagonalColorBox = (props) => {
  return (
    <div
      onClick={() => {
        props.onThemeClick(props.data);
      }}
      style={{
        border: `2px solid ${
          props.selected ? "var(--tertiaryColor)" : "var(--primaryColor)"
        }`
      }}
    >
      <div
        className="margin-small"
        style={{
          width: "61px",
          height: "32px",
          position: "relative",
          backgroundColor: props.data?.primaryColor
        }}
      >
        <div
          style={{
            width: 0,
            height: 0,
            borderLeft: `20px solid ${props.data?.secondaryColor}`,
            borderBottom: `20px solid transparent`,
            position: "absolute"
          }}
        />
      </div>
    </div>
  );
};

const ThemesContainer = (props) => {
  const themesData = [
    {
      primaryColor: "#0E0E0E",
      secondaryColor: "#20C74F",
      secondaryColor1: "#0C2713",
      tertiaryColor: "#FFFFFF",
      tertiaryColor1: "#1C1C1C",
      tertiaryColor2: "#262626",
      tertiaryColor3: "#353535",
      tertiaryColor4: "#3E3E3E",
      tertiaryColor5: "#6E6E6E",
      tertiaryColor6: "#CFCFCF",
      tertiaryColor7: "#ECECEC",
      tertiaryColor8: "#212121",
      tertiaryColor9: "#ffffff14"
    },
    {
      primaryColor: "#0E0E0E",
      secondaryColor: "#6EB3F4",
      secondaryColor1: "#18232E",
      tertiaryColor: "#FFFFFF",
      tertiaryColor1: "#1C1C1C",
      tertiaryColor2: "#262626",
      tertiaryColor3: "#353535",
      tertiaryColor4: "#3E3E3E",
      tertiaryColor5: "#6E6E6E",
      tertiaryColor6: "#CFCFCF",
      tertiaryColor7: "#ECECEC",
      tertiaryColor8: "#212121",
      tertiaryColor9: "#ffffff14"
    },
    {
      primaryColor: "#0E0E0E",
      secondaryColor: "#FFFFFF",
      secondaryColor1: "#2F2F2F",
      tertiaryColor: "#FFFFFF",
      tertiaryColor1: "#1C1C1C",
      tertiaryColor2: "#262626",
      tertiaryColor3: "#353535",
      tertiaryColor4: "#3E3E3E",
      tertiaryColor5: "#6E6E6E",
      tertiaryColor6: "#CFCFCF",
      tertiaryColor7: "#ECECEC",
      tertiaryColor8: "#212121",
      tertiaryColor9: "#ffffff14"
    },
    {
      primaryColor: "#0E0E0E",
      secondaryColor: "#9F5EEE",
      secondaryColor1: "#20162D",
      tertiaryColor: "#FFFFFF",
      tertiaryColor1: "#1C1C1C",
      tertiaryColor2: "#262626",
      tertiaryColor3: "#353535",
      tertiaryColor4: "#3E3E3E",
      tertiaryColor5: "#6E6E6E",
      tertiaryColor6: "#CFCFCF",
      tertiaryColor7: "#ECECEC",
      tertiaryColor8: "#212121",
      tertiaryColor9: "#ffffff14"
    },
    {
      primaryColor: "#F3F3F3",
      secondaryColor: "#0A9231",
      secondaryColor1: "#CEE3D4",
      tertiaryColor: "#0E0E0E",
      tertiaryColor1: "#FFFFFF",
      tertiaryColor2: "#FFFFFF",
      tertiaryColor3: "#CFCFCF",
      tertiaryColor4: "#AFAFAF",
      tertiaryColor5: "#6E6E6E",
      tertiaryColor6: "#353535",
      tertiaryColor7: "#262626",
      tertiaryColor8: "#E1E1E1",
      tertiaryColor9: "#00000014"
    },
    {
      primaryColor: "#F3F3F3",
      secondaryColor: "#4D8ECB",
      secondaryColor1: "#D8E3ED",
      tertiaryColor: "#0E0E0E",
      tertiaryColor1: "#FFFFFF",
      tertiaryColor2: "#FFFFFF",
      tertiaryColor3: "#CFCFCF",
      tertiaryColor4: "#AFAFAF",
      tertiaryColor5: "#6E6E6E",
      tertiaryColor6: "#353535",
      tertiaryColor7: "#262626",
      tertiaryColor8: "#E1E1E1",
      tertiaryColor9: "#00000014"
    },
    {
      primaryColor: "#F3F3F3",
      secondaryColor: "#0E0E0E",
      secondaryColor1: "#CECECE",
      tertiaryColor: "#0E0E0E",
      tertiaryColor1: "#FFFFFF",
      tertiaryColor2: "#FFFFFF",
      tertiaryColor3: "#CFCFCF",
      tertiaryColor4: "#AFAFAF",
      tertiaryColor5: "#6E6E6E",
      tertiaryColor6: "#353535",
      tertiaryColor7: "#262626",
      tertiaryColor8: "#E1E1E1",
      tertiaryColor9: "#00000014"
    },
    {
      primaryColor: "#F3F3F3",
      secondaryColor: "#874AD1",
      secondaryColor1: "#E2D8EE",
      tertiaryColor: "#0E0E0E",
      tertiaryColor1: "#FFFFFF",
      tertiaryColor2: "#FFFFFF",
      tertiaryColor3: "#CFCFCF",
      tertiaryColor4: "#AFAFAF",
      tertiaryColor5: "#6E6E6E",
      tertiaryColor6: "#353535",
      tertiaryColor7: "#262626",
      tertiaryColor8: "#E1E1E1",
      tertiaryColor9: "#00000014"
    }
  ];

  const findTheIndexOfThemeData = (data) => {
    return themesData.findIndex(
      (theme) =>
        theme.primaryColor === data.primaryColor &&
        theme.secondaryColor === data.secondaryColor
    );
  };

  return (
    <div
      style={{
        gap: "12px"
      }}
      className="display-flex flex-wrap flex-justify-content-center"
    >
      {themesData.map((data, i) => (
        <div key={i} className="display-flex">
          <DiagonalColorBox
            selected={i === findTheIndexOfThemeData(props.selectedTheme)}
            onThemeClick={props.onThemeClick}
            data={data}
          />
        </div>
      ))}
    </div>
  );
};
